export const GET_LOCALMACHINEINFO_START = 'GET_LOCALMACHINEINFO_START';
export const GET_LOCALMACHINEINFO_SUCCESS = 'GET_LOCALMACHINEINFO_SUCCESS';
export const GET_LOCALMACHINEINFO_FAILURE = 'GET_LOCALMACHINEINFO_FAILURE';
export const GET_LOCALSOFT_START = 'GET_LOCALSOFT_START';
export const GET_THROTTLE_LOCALSOFT_START = 'GET_THROTTLE_LOCALSOFT_START';
export const GET_LOCALSOFT_SUCCESS = 'GET_LOCALSOFT_SUCCESS';
export const GET_LOCALSOFT_INIT_SUCCESS = 'GET_LOCALSOFT_INIT_SUCCESS';
export const GET_LOCALSOFT_FAILURE = 'GET_LOCALSOFT_FAILURE';
export const REQUEST_NATIVE_INSTALL = 'REQUEST_NATIVE_INSTALL';
export const REQUEST_NATIVE_INSTALL_LIST = 'REQUEST_NATIVE_INSTALL_LIST';
export const REQUEST_NATIVE_UNINSTALL = 'REQUEST_NATIVE_UNINSTALL';
export const REQUEST_NATIVE_UPGRADE = 'REQUEST_NATIVE_UPGRADE';
export const GET_OTHER_INFO = 'GET_OTHER_INFO';
export const SET_OTHER_INFO = 'SET_OTHER_INFO';
export const SET_COMMAND_LINE = 'SET_COMMAND_LINE';
export const SET_WELCOME_IDS = 'SET_WELCOME_IDS';
export const DELETE_WELCOME_IDS = 'CLEAR_WELCOME_IDS';
export const REMOVE_UNINSTALL_SOFT = 'REMOVE_UNINSTALL_SOFT';

export const SILENT_SOFT_INSTALL_INFOS_START = 'SILENT_SOFT_INSTALL_INFOS_START';
export const SILENT_SOFT_INSTALL_INFOS_SUCCESS = 'SILENT_SOFT_INSTALL_INFOS_SUCCESS';
export const SILENT_SOFT_INSTALL_INFOS_FAILURE = 'SILENT_SOFT_INSTALL_INFOS_FAILURE';

// 5.3
export const SET_QUIET_INSRALL_PATH = 'SET_QUIET_INSRALL_PATH';

// v7.0
export const SET_UPDATE_NOTIFY_STATUS = 'SET_UPDATE_NOTIFY_STATUS';

// v7.3
export const SET_RESIDUAL_NOTIFY_STATUS = 'SET_RESIDUAL_NOTIFY_STATUS'; // 设置残留弹窗开启状态
export const SET_RARELY_NOTIFY_STATUS = 'SET_RARELY_NOTIFY_STATUS'; // 不常用软件弹窗开启状态
